
<div class="modal-dialog confirm-dialog" style="min-width: 850px; min-height: 400px;">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">Add New Fleet</h4>
      <button class="close" type="button" (click)="cancel()">&times;</button>
    </div>
    <div class="modal-body">
      <error [error]="error"></error>
      <div class="row">
        <div class="form-group col-6">
          <label class="required" for="fleetName">Fleet Name</label>
          <input class="form-control" id="fleetName" [(ngModel)]="fleetName" name="fleetName" placeholder="Enter Fleet Name">
        </div>
        <div class="form-group col-6">
          <label class="required" for="fleetId">Fleet Id</label>
          <input class="form-control" id="fleetId" [(ngModel)]="fleetId" name="fleetId" [disabled]="true">
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-outline-secondary pl-5 pr-5" type="button" (click)="cancel()">Cancel</button>
      <button class="btn btn-outline-primary pl-5 pr-5" type="button" (click)="create()" [ngClass]="{ 'btn-outline-secondary': !(fleetName !== '' &amp;&amp; fleetName !== '') }" [disabled]="!(fleetName !== '' &amp;&amp; fleetName !== '')">Create</button>
    </div>
  </div>
</div>